<template>
  <div v-if="financial !== null">
    <h3 class="mb-5">公司年報</h3>

    <!-- 上傳檔案 -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4 class="mb-10px">上傳檔案</h4>
        <div class="h5 ink-02-medium--text">
          建議檔案格式：PDF <br />
          檔案大小限制：&lt; 1 MB
        </div>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <FileUploader
          v-model="financial.annual_report"
          dir="ir"></FileUploader>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploader from '@/components/FileUploader.vue';

export default {
  props: {
    financial: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    FileUploader,
  },
};
</script>

<style></style>
